import { useAuth0 } from '@auth0/auth0-react';
import { Loader } from 'components/common/Loader';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

function SignExtensionPage() {
  const { loginWithRedirect } = useAuth0();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    loginWithRedirect({ 
      authorizationParams: { 
        redirect_uri: `${process.env.REACT_APP_AUTH0_REDIRECT_API}?type=extension&localServerPort=${searchParams.get('localServerPort') || 0}` || window.location.origin,
      }
    });
  }, []);
  return (
    <>
      <Loader />
    </>
  );
}

export default SignExtensionPage;
